module.exports = __webpack_public_path__ + "img/Ethereum-QR.00c3eefc.svg";